import { render, staticRenderFns } from "./AbsenceTypeNewForm.vue?vue&type=template&id=8512b7a6"
import script from "./AbsenceTypeNewForm.vue?vue&type=script&lang=js"
export * from "./AbsenceTypeNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports